import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgModule } from '@angular/core';

import { MessageBoxModule } from '@component/message-box';
import { MessageCommunicationTypesModule } from '@component/message-communication-types';
import { MessageInputModule } from '@component/message-input';

import { MemberModalComponent } from './member-modal.component';
import { IsPrimaryContactPipe } from './is-primary-contact.pipe';

@NgModule({
  declarations: [IsPrimaryContactPipe, MemberModalComponent],
  exports: [IsPrimaryContactPipe, MemberModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    InlineSVGModule,
    MatCheckboxModule,
    MatInputModule,
    MatSlideToggleModule,
    MessageCommunicationTypesModule,
    MessageInputModule,
    MessageBoxModule
  ]
})
export class MemberModalModule {}
